export interface PermissionsSchema {
  permissions: Record<string, Record<string, Record<string, ActionSchema>>>;
}

export interface ActionSchema {
  enabled: boolean;
  policy: string;
}
